module.exports = __webpack_public_path__ + "img/4.67c73608.jpg";